import React, { createContext, useEffect, useState } from 'react';
import { ListProductsState, ProductObj, useProducts } from '@lyonfuture/api';

type ProductProviderProps = {
  children: React.ReactNode;
};

export type ProductContextProps = {
  products: ProductObj[];
  productMap: Record<string, ProductObj> | null;
};

export const ProductContext = createContext<ProductContextProps>({
  products: [],
  productMap: null,
});

export const ProductProvider = ({ children }: ProductProviderProps) => {
  const productsState = useProducts() as ListProductsState;
  const [value, setValue] = useState<ProductContextProps>({
    products: [],
    productMap: null,
  });

  useEffect(() => {
    if (productsState.fetched && productsState.data) {
      setValue({
        products: productsState.data,
        productMap: productsState.data.reduce(
          (map, productObj) => {
            map[productObj.productId.id] = productObj;
            return map;
          },
          {} as Record<string, ProductObj>,
        ),
      });
    }
  }, [productsState.fetched]);

  return (
    <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
  );
};

export default ProductProvider;
